(function () {
  'use strict';

  angular
      .module('tfc.retailer.BrandSelection')
      .directive('tfcBrandSelection', tfcBrandSelection)
      .controller('BrandSelectionCtrl', BrandSelectionCtrl)
      .controller('BrandSelectionModalCtrl', BrandSelectionModalCtrl)
      .directive('tfcBrandSelectionAutoFocus',tfcBrandSelectionAutoFocus)
      .constant('BrandTypeAheadThreshold', 100)
      .constant('BrandSearchThreshold',10);

  function tfcBrandSelection() {
    return {
      restrict: 'E',
      controller : 'BrandSelectionCtrl as vm',
      templateUrl : 'Util/BrandSelection/BrandSelection.tmpl.html',
      bindToController : true,
      scope : {
        selectedBrand : '=',
        brands: '=',
        reload: '='
      }
    };
  }
  
  function tfcBrandSelectionAutoFocus() {
    return {
      restrict: 'A',
      require:'ngModel',
      link: function (scope, element, attrs) {
        var focusElem = element[0];
        if(focusElem) {
          var focusElemVal = _.get(scope, attrs.ngModel);
          focusElem.focus();
          focusElem.value = focusElemVal.name;
          focusElem.select();
          focusElem.onfocus = function () {
            focusElem.select();
          };
        }
      }
    };
  }

  function BrandSelectionCtrl($uibModal) {
    var vm = this;
    vm.openModal = function (size) {
      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        templateUrl: 'Util/BrandSelection/BrandSelectionModal.tmpl.html',
        controller: 'BrandSelectionModalCtrl',
        controllerAs: 'vm',
        size: size,
        resolve: {
          selectedBrand: function() {
            return vm.selectedBrand;
          },
          brands: function() {
            return vm.brands;
          },
          reload: function() {
            return vm.reload;
          }
        }
      });
    };
  }

  function BrandSelectionModalCtrl(selectedBrand, $uibModalInstance, brands, reload, CookieJar, $state, BrandTypeAheadThreshold, BrandSearchThreshold) {
    var vm = this;
    vm.selectedBrand = selectedBrand;
    vm.showBrandTypeAhead = function(){
      return vm.brands.length <= BrandTypeAheadThreshold;
    };
    vm.showBrandSearch = function(){
      return vm.brands.length > BrandSearchThreshold;
    };
    vm.brands = brands;
    vm.reload = reload;
    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
    vm.setActiveBrand = function(brand){
      vm.selectedBrand = brand;
      vm.reload(brand);
      $uibModalInstance.dismiss('cancel');
    };
    vm.isBrandActive = function(brand){
      return brand === vm.selectedBrand;
    };
    vm.onSelect = function ($item, $model, $label) {
      vm.selectedBrand = $item;
      vm.reload(vm.selectedBrand);
      $uibModalInstance.dismiss('cancel');
    };
    vm.brandMatches = function(search){
      return function (brand) {
        return !search || brand.name.substr(0, search.length).toLowerCase().indexOf(search.toLowerCase()) >= 0;
      };
    };

  }

})();